import styled from "styled-components";

export const InsightStyled = styled.div`
  &:not(.landscape) {
    padding: 32px 35px;
    .keyDrivers {
      padding-top: 10px;
    }
    .keyDrivers:first-of-type {
      padding-top: 0px;
    }
  }
  &.landscape {
    padding: 20px 35px;
  }

  @media print {
    &:not(.landscape) {
      max-width: 820px !important;
    }
    &.landscape {
      max-width: 1055px !important;
      padding-top: 14px;
      padding-bottom: 14px;
      h2 {
        margin-bottom: 8px;
      }
      .circle-label {
        left: -3px !important;
      }
    }
  }

  h2 {
    display: inline-block;
  }

  &.breathing-room {
    padding-top: 20px;

    p {
      margin-top: 5px;
      margin-bottom: 5px;
    }
  }

  .ui.grid {
    margin-left: -0.25rem;
    margin-right: -0.25rem;

    & > .row > .column {
      padding-left: 0.25rem;
      padding-right: 0.25rem;
    }
  }

  .whatever {
    margin-top: -7px;
  }

  .gl-container {
    display: none;
  }

  svg:last-child {
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
      transform: translateY(-2px);
    }
    @media print {
      transform: translateY(-150px);
    }
  }

  &&& {
    h2 {
      letter-spacing: 1px;
    }
    h3 {
      text-transform: uppercase;
      font-weight: bold;
      font-size: 13px;
      letter-spacing: 1px;
      margin-bottom: 0px !important;
      white-space: nowrap;
    }
    p {
      font-size: 13px;
    }
  }
  .noPadBottomRow {
    padding-top: 20px !important;
    padding-bottom: 0 !important;

    @media print {
      padding-top: 10px !important;
    }

    &.breathing-room {
      padding-top: 28px !important;
    }
  }
  .noPadRow {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .donut-graph {
    position: relative;
  }

  .circle-background {
    height: 60px;
    width: 60px;
    border-radius: 100px;
    background: rgba(105, 191, 117, 0.2);
    border: 2px solid #69bf75;
    position: absolute;
    bottom: 39px;
    left: 42px;
  }

  .circle-arrow {
    color: #69bf75;
    height: 84px;
    position: absolute;
    bottom: 27px;
    left: 67px;
    transform: rotate(0deg);
    font-size: 12px;
  }

  .circle-label {
    height: 116px;
    width: 100%;
    position: absolute;
    bottom: 12px;
    left: 0;
    transform: rotate(0deg);
    font-size: 10px;
    text-align: center;
    z-index: 100;
    pointer-events: none;

    @media print {
      left: -1px;
    }
  }

  .ui p.instructions {
    font-size: 15px;
    position: absolute;
    margin: 0 5px 0 0;
  }

  .keyDrivers {
    display: flex;
    justify-content:flex-start;
  }

  .keyDriver {
    width: 152px;
    height: 188px;
    padding: 0 4px;

    &:first-child {
      margin-left: 0;
      padding-left: 0;
    }

    &:last-child {
      margin-right: 0;
      padding-right: 0;
    }

    p {
      height: 36px;
      margin-bottom: 0;
    }
  }
`;

export const NoCircle = styled.div`
  text-align: center;
  padding: 28px 7px;
`;



// WEBPACK FOOTER //
// ./src/components/KeyDriverCircles/style.js